import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/buyer-add',
      name: 'admin-buyer-add',
      component: () => import(/* webpackChunkName: "page-admin-buyer-management-buyer-add" */ `./1.0.5/index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "添加分销商"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "分销商管理"
                                        },
                                        {
                                                  name: "添加分销商"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
